<!-- eslint-disable -->
<template lang="pug">
    .olympiad-preview(:class="{'olympiad-preview--archived': olympiad.status === 'archived'}")
        .olympiad-preview__logo
            img.olympiad-preview__image(:src="olympiad.logo")
        .olympiad-preview__title
           | {{ olympiad.title }}
        .olympiad-preview__container
            .olympiad-preview__name
                | {{ olympiad.name }}
            .olympiad-preview__time-block(v-if="olympiad.status !== 'archived'")
                .olympiad-preview__date
                    svg-icon.olympiad-preview__icon(name="calendar" height="24" width="24")
                    span.olympiad-preview__date-text {{ $i18n.t('olympiads.olympiads_registerPage_olympiadWillBeHeld') }} &nbsp; {{ formattedDate }}
                =" "
                .olympiad-preview__date(v-if="withTime && time")
                    svg-icon.olympiad-preview__icon(name="clock-o" height="24" width="24")
                    span.olympiad-preview__date-text {{ time }}
        .olympiad-preview__register(v-if="olympiad.status !== 'archived' && !withSlot")
            .olympiad-preview__registration
                a(:href="olympiad.rulesLink" target="_blank") {{ $i18n.t('olympiads.olympiads_preview_theRulesOfTheOlympiad') }}
            .olympiad-preview__registration
                span.olympiad-preview__date-of-olympiad(v-text="registrationStatus")
            .olympiad-preview__registration(
                v-if="showStatus && (user.type === 'student' || user.type === 'olympiads-student')"
            )
                template(v-if="olympiad.authUserRegisteredLevel")
                    span(v-if="olympiad.authUserRegisteredLevel.authCompletedUser.length")
                        | {{ $i18n.t('olympiads.olympiads_preview_allTasksCompleted') }}
                    span(v-else) {{ $i18n.t('olympiads.olympiads_preview_applicationIsAccepted') }}
                template(v-else-if="olympiad.isRegistrationEnded")
                    span {{ $i18n.t('olympiads.olympiads_preview_registrationEnded') }}
        .olympiad-preview__additional-text(v-else)
            span.header__text
                slot
</template>

<script>
    /*eslint-disable*/
    import moment from "moment-timezone";
    import {mapState} from 'vuex';

    const timezone = 'Europe/Moscow';

    export default {
        props: {
            olympiad: Object,
            withTime: Boolean,
            showStatus: Boolean,
            withSlot: Boolean
        },
        created() {
            moment.locale(this.$i18n.locale);
        },
        computed: {
            registrationStatus() {
                if (this.olympiad.status !== 'archived') {
                    let currentTime = moment.tz(timezone);
                    if (this.isRegistrationAllowed) {
                        return this.$i18n.t('olympiads.olympiads_preview_registerWillEnd')
                                + moment(this.olympiad.registrationEnd).format('DD MMM YYYY')
                                + this.$i18n.t('olympiads.olympiads_preview_in')
                                + moment(this.olympiad.registrationEnd).format('HH:mm')
                                + this.$i18n.t('olympiads.olympiads_preview_timezone');
                    } else if (currentTime.isBefore(moment.tz(this.olympiad.registrationStart, timezone))) {
                        return this.$i18n.t('olympiads.olympiads_preview_registerWillBegin')
                                + moment(this.olympiad.registrationStart).format('DD MMM YYYY')
                                + this.$i18n.t('olympiads.olympiads_preview_in')
                                + moment(this.olympiad.registrationStart).format('HH:mm')
                                + this.$i18n.t('olympiads.olympiads_preview_timezone');
                    }
                }
                return this.$i18n.t('olympiads.olympiads_preview_registerIsClosed');
            },
            isRegistrationAllowed() {
                return moment.tz(timezone).isBetween(
                        moment.tz(this.olympiad.registrationStart, timezone),
                        moment.tz(this.olympiad.registrationEnd, timezone)
                );
            },
            formattedDate() {
                return moment(this.olympiad.date).format('DD MMM YYYY')
            },
            time() {
                if (this.user.type === 'student' || this.user.type === 'olympiads-student') {
                    let level = this.olympiad.levels.find(level => {
                        if (level.authRegisteredUser.length) {
                            level.endTime = level.endTime || level.stages[level.stages.length - 1].endTime;
                        }
                        return level.authRegisteredUser.length;
                    });
                    return level ? level.startTime + '-' + level.endTime : null;
                }
                return null;
            },
            ...mapState({
                user: state => state.auth.user
            })
        }
    }
</script>

<style lang="scss" scoped>

    .olympiad-preview--archived {
        .olympiad-preview__image {
            border: 3px solid #EABA5A;
        }
        .olympiad-preview__title {
            color: #D0BC90;
        }
        .olympiad-preview__name {
            color: #EABA5A;
        }
    }

    .olympiad-preview {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
    }

    .olympiad-preview__logo {
        text-align: center;
        margin: 15px 0;
    }

    .olympiad-preview__image {
        border-radius: 50%;
        max-width: 100px;
        max-height: 100px;
    }

    .olympiad-preview__title {
        text-align: center;
        font-size: 14px;
        margin-bottom: 20px;
    }

    .olympiad-preview__container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .olympiad-preview__name {
        text-align: center;
        font-size: 18px;
        font-weight: 500;
        margin-bottom: 15px;
        @include media($md) {
            font-size: 20px;
        }
        @include media($xlg) {
            font-size: 22px;
        }
    }

    .olympiad-preview__date {
        font-size: 14px;
        display: flex;
        margin-bottom: 35px;
    }

    .olympiad-preview__icon {
        color: $hsl-color-green-58;
        margin-right: 15px;
    }

    .olympiad-preview__date-text {
        padding-top: 4px;
    }

    .olympiad-preview__registration {
        text-align: center;
        @include stack-space($margin-xs);
    }

    .olympiad-preview__date-of-olympiad {
        color: $hsl-color-gray-52;
    }

    .olympiad-preview__additional-text {
        text-align: center;
        font-size: 24px;
        font-weight: 700;
        color: #FF7245;
        @include media($md) {
            font-size: 30px;
        }
    }
</style>
